// ─────────────────────────────────────────────────────────────────────────────
// Projects & Products Data
// type: "product"  → published / revenue-generating software
// type: "project"  → portfolio / learning / demo projects
// images: array of filenames in /public/assets/images/
// ─────────────────────────────────────────────────────────────────────────────

export const projects = [
  // ── PRODUCTS ──────────────────────────────────────────────────────────────
  {
    id: 1,
    name: "Fusion Fitness JA",
    description:
      "Fusion Fitness JA is the official mobile community app for members of Fusion Fitness JA Gym in Jamaica. Track workouts, compete on leaderboards, and stay connected with fellow members in real-time.",
    tech: ["Flutter", "Dart", "Firebase", "REST API"],
    category: "Mobile",
    type: "product",
    images: ["fusionfitness.jpeg", "fusionfitness2.jpeg", "fusionfitness3.jpeg", "fusionfitness4.jpeg","fusionfitness5.jpeg"],   // add more e.g. ["fusionfitness.jpeg", "fusionfitness2.jpeg"]
    github: null,
    live: null,
    playStore: "https://play.google.com/store/apps/details?id=com.fusionfitness.fusion_fitness",
    appStore: "https://apps.apple.com/jm/app/fusion-fitness-ja/id6752257505",
  },
  {
    id: 2,
    name: "Orbital Defender",
    description:
      "A physics-based mobile arcade game built with Flutter. Players redirect incoming meteors to protect the core, collect stardust, and unlock unique survival cores as difficulty increases.",
    tech: ["Flutter", "Dart", "Firebase","AdMob"],
    category: "Mobile",
    type: "product",
    images: ["orbital.jpeg", "orbital2.jpeg", "orbital3.jpeg","orbital4.jpeg"],      // add more e.g. ["orbital.jpeg", "orbital2.jpeg"]
    github: null,
    live: null,
    playStore: null,
    appStore: "https://apps.apple.com/jm/app/the-orbital-defender/id6758585573",
  },

  // ── PROJECTS ──────────────────────────────────────────────────────────────

  {
  id: 3,
  name: "SummAIze - AI Summarizer",
  description:
    "SummAIze is an AI-powered web application that automatically summarizes long articles into short, clear, and readable summaries. It uses natural language processing through a REST API to analyze large bodies of text and extract the most important information, helping users quickly understand key ideas and save time when reading lengthy content.",
  tech: ["React.js", "Tailwind CSS", "REST API", "JavaScript", "HTML", "CSS"],
  category: "Web",
  type: "project",
  images: ["summaize.jpeg"],
  github: "https://github.com/NakardaRichards/SummAIze",
  live: "https://summ-a-ize.vercel.app/",
  playStore: null,
  appStore: null,
},
{
  id: 4,
  name: "FlixTube - YouTube Clone",
  description:
    "FlixTube is a responsive YouTube-inspired web application built with React. It integrates the YouTube Data API through RapidAPI to display trending videos, channel details, and search results in a modern interface designed with Material UI.",
  tech: ["React.js", "Material UI", "RapidAPI", "JavaScript"],
  category: "Web",
  type: "project",
  images: [
    "flixtube.jpeg",
    "flixtube2.jpeg",
    "flixtube3.jpeg"
  ],
  github: "https://github.com/NakardaRichards/FlixTube",
  live: "https://flix-tube.vercel.app/",
  playStore: null,
  appStore: null,
},
{
  id: 5,
  name: "CRead - Online Learning Platform",
  description:
    "CRead is an online learning platform built with PHP and MySQL. Students can register for courses, access videos and learning materials, take tests, and earn certificates upon completion. The platform uses environment variables for secure database connection management.",
  tech: ["PHP", "MySQL", "Bootstrap","JavaScript"],
  category: "Web",
  type: "project",
  images: ["cread.jpeg"],
  github: "https://github.com/NakardaRichards/CRead",
  live: null,
  playStore: null,
  appStore: null,
},
{
  id: 6,
  name: "QuickNotes - Shared Notepad API",
  description:
    "QuickNotes is a lightweight shared notepad built with Node.js and Express backed by MongoDB. Anyone can create, edit, and delete notes in real time. Features locked pinned notes, rate limiting, auto cleanup, and a clean vanilla JS frontend. Deployed on Vercel.",
  tech: ["Node.js", "Express", "MongoDB", "HTML", "JavaScript", "Vercel"],
  category: "API",
  type: "project",
  images: ["quicknotes.jpeg"],
  github: "https://github.com/nakardarichards/quicknotes-express",
  live: "https://quicknotes-express.vercel.app",
  playStore: null,
  appStore: null,
},
{
  id: 7,
  name: "QuickQR - QR Code Generator API",
  description:
    "QuickQR is a QR code generator API built with Node.js and Express. POST any text or URL and get back a PNG image instantly. Supports custom size, foreground and background colors. Includes a clean vanilla JS frontend. Deployed on Vercel.",
  tech: ["Node.js", "Express", "HTML", "JavaScript", "Vercel"],
  category: "API",
  type: "project",
  images: ["quickqr.jpeg", "quickqr2.jpeg"],
  github: "https://github.com/nakardarichards/quickqr",
  live: "https://quickqr-swart.vercel.app/",
  playStore: null,
  appStore: null,
},

];